import { get } from "lodash";
import { CustomColumnType, getCustomColumnTypes } from "./grid-column-types";
export const getValue = (dataRow, dataPath) => {
    if (Array.isArray(dataPath)) {
        return dataPath.reduce((prev, current) => {
            if (prev === null && (get(dataRow, current) || get(dataRow, current) === 0)) {
                return get(dataRow, current);
            }
            return prev;
        }, null);
    }
    return get(dataRow, dataPath);
};
export const dynamicValueFormatter = (params) => {
    if (getCustomColumnTypes("")[params.data.type]?.valueFormatter && getCustomColumnTypes("")[params.data.type].valueFormatter instanceof Function) {
        return getCustomColumnTypes("")[params.data.type].valueFormatter(params);
    }
    return "";
};
export const dynamicCellRenderer = (params) => {
    const cellRenderer = getCustomColumnTypes("")[params.data.type]?.cellRenderer;
    return { component: cellRenderer, params };
};
const canTransposedColumnsBeFiltered = (columnDefs) => {
    if (columnDefs) {
        return !columnDefs.some((columnDef) => columnDef.filter === false);
    }
    return true;
};
export const transposition = (props, transposedColumnsKey, transposedColProps) => {
    let columnDefs = [], rowData = [];
    const id = "id";
    const columnsKey = transposedColumnsKey ?? id;
    const firstColumn = { cellClass: "transposedGridFirstColumn",
        field: id,
        headerName: "" };
    if (props.rowData && props.columnDefs) {
        columnDefs = props.rowData.map((row) => ({ ...transposedColProps || {},
            cellRendererSelector: dynamicCellRenderer,
            field: row[columnsKey],
            filter: canTransposedColumnsBeFiltered(props.columnDefs),
            headerName: row[columnsKey],
            type: CustomColumnType.InsTransposedColumn,
            valueFormatter: dynamicValueFormatter }));
        columnDefs.unshift(props.columnDefs.find((col) => col.field === id) || firstColumn);
        rowData = props.columnDefs.filter((col) => col.field !== id && col.field !== "CustomGroup").map((def) => {
            const line = {};
            line.id = def.headerName;
            line.type = def.type;
            props.rowData?.forEach((row) => {
                line[row[columnsKey]] = row[def.field];
            });
            return line;
        });
    }
    return { columnDefs, rowData };
};
export const getDatapointGridStateId = (sectionId, widgetId) => `${sectionId}-${widgetId}-Grid`;
